import { NewReview } from '@/domain/review'
import { apiClient } from '@/infrastructure/api'
import { OpsApi, OpspbRefundOverride } from '@itsrever/rever-api'
import { toApiReviews } from './dto'

const opsApi = new OpsApi(undefined, undefined, apiClient)

export async function createReview(
  processId: string,
  reviews: NewReview[],
  refundOverride: OpspbRefundOverride
) {
  const createReviewResponse = await opsApi.reviewItems(
    toApiReviews(processId, reviews, refundOverride)
  )
  return createReviewResponse.data
}
